module.exports = __webpack_public_path__ + "static/media/1030008.70f27bc5.jpg";